export enum InvoicePaymentStatus {
  AwaitingProcessing,
  AwaitingPayment,
  Paid,
  Void,
  Archived
}